// Admin routes for P5-C (CHECKOUT, ORDER, CUSTOMER, PROMOTION, RISK, PAYMENT manual, SETTINGS tax, ANALYTICS basic, NOTIFY templates). Owned by that worker; the router mounts whatever this returns under the
// app shell (before the store-area placeholder), so modules never edit router.tsx.
// Paths follow the nav tree (shell/nav.ts): orders, customers, money/payments, marketing/promotions,
// settings/taxes. The Today KPIs component (orders/TodayKpis.tsx) is mounted by the lead in Today.
import {
  createRoute,
  type AnyRoute,
  type RouteComponent,
  lazyRouteComponent,
} from "@tanstack/react-router";

// Pages are code-split: each loads when its route opens, not with the shell.
const load1 = () => import("../customers/CustomersPage");
const CustomerDetailPage = lazyRouteComponent(load1, "CustomerDetailPage");
const CustomersPage = lazyRouteComponent(load1, "CustomersPage");
const load2 = () => import("../orders/OrdersPage");
const OrdersPage = lazyRouteComponent(load2, "OrdersPage");
const load3 = () => import("../orders/PrintPage");
const PrintPage = lazyRouteComponent(load3, "PrintPage");
const load4 = () => import("../orders/UnfinishedPage");
const UnfinishedPage = lazyRouteComponent(load4, "UnfinishedPage");
const load5 = () => import("../payments/PaymentsPage");
const PaymentsPage = lazyRouteComponent(load5, "PaymentsPage");
const load6 = () => import("../settings/TaxesPage");
const TaxesPage = lazyRouteComponent(load6, "TaxesPage");
const load7 = () => import("../promotions/CouponsPage");
const CouponsPage = lazyRouteComponent(load7, "CouponsPage");

export function commerceRoutes(appRoute: AnyRoute): AnyRoute[] {
  const r = (path: string, component: RouteComponent) =>
    createRoute({ getParentRoute: () => appRoute, path, component }) as unknown as AnyRoute;
  return [
    r("/$org/$store/orders", OrdersPage),
    r("/$org/$store/orders/unfinished", UnfinishedPage),
    r("/$org/$store/orders/print", PrintPage),
    r("/$org/$store/orders/$orderId", OrdersPage),
    r("/$org/$store/customers", CustomersPage),
    r("/$org/$store/customers/$customerId", CustomerDetailPage),
    r("/$org/$store/money/payments", PaymentsPage),
    r("/$org/$store/marketing/promotions", CouponsPage),
    r("/$org/$store/settings/taxes", TaxesPage),
  ];
}
